import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import {
	LoyaltyBalance,
	LoyaltyHistoryFilter,
	LoyaltyHistoryResponse,
	LoyaltyLevelDetail,
	LoyaltyMonthlyHistoryResponse,
} from "./loyalty.model";

export const ACTION_PREFIX = "[Loyalty]";
export const LOYALTY_ACTION_TYPE = {
	getBalance: `${ACTION_PREFIX} Get Balance`,
	getBalanceSuccess: `${ACTION_PREFIX} Get Balance Success`,
	getBalanceFail: `${ACTION_PREFIX} Get Balance Fail`,

	getBrandLoyaltyLevels: `${ACTION_PREFIX} Get Brand Loyalty Levels`,
	getBrandLoyaltyLevelsSuccess: `${ACTION_PREFIX} Get Brand Loyalty Levels Success`,
	getBrandLoyaltyLevelsFail: `${ACTION_PREFIX} Get Brand Loyalty Levels Fail`,

	getHistory: `${ACTION_PREFIX} Get History`,
	getHistorySuccess: `${ACTION_PREFIX} Get History Success`,
	getHistoryFail: `${ACTION_PREFIX} Get History Fail`,
	clearHistory: `${ACTION_PREFIX} Clear History ${SYNC_SUFFIX}`,

	getMonthlyHistory: `${ACTION_PREFIX} Get Monthly History`,
	getMonthlyHistorySuccess: `${ACTION_PREFIX} Get Monthly History Success`,
	getMonthlyHistoryFail: `${ACTION_PREFIX} Get Monthly History Fail`,

	exchangePoints: `${ACTION_PREFIX} Exchange points`,
	exchangePointsSuccess: `${ACTION_PREFIX} Exchange points Success`,
	exchangePointsFail: `${ACTION_PREFIX} Exchange points Fail`,
};

@Injectable({
	providedIn: "root",
})
/**
 * @deprecated [fabric-deprecated] - use fabric LoyaltyService from app-account instead
 */
export class LoyaltyAction {
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.dispatch(AccountAppCommand.LoyaltyClearHistory)" instead
	 */
	clearHistory(): Action {
		return {
			type: LOYALTY_ACTION_TYPE.clearHistory,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.LoyaltyLevel)" instead
	 */
	getBrandLoyaltyLevels(): Action {
		return {
			type: LOYALTY_ACTION_TYPE.getBrandLoyaltyLevels,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.LoyaltyLevel)" instead
	 */
	getBrandLoyaltyLevelsSuccess(payload: LoyaltyLevelDetail[]): ActionWithPayload {
		return {
			type: LOYALTY_ACTION_TYPE.getBrandLoyaltyLevelsSuccess,
			payload,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.LoyaltyLevel)" instead
	 */
	getBrandLoyaltyLevelsFail(payload: AppError): ActionWithPayload {
		return {
			type: LOYALTY_ACTION_TYPE.getBrandLoyaltyLevelsFail,
			payload,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.LoyaltyBalance)" instead
	 */
	getBalance(): Action {
		return {
			type: LOYALTY_ACTION_TYPE.getBalance,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.LoyaltyBalance)" instead
	 */
	getBalanceSuccess(payload: LoyaltyBalance): ActionWithPayload {
		return {
			type: LOYALTY_ACTION_TYPE.getBalanceSuccess,
			payload,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.LoyaltyBalance)" instead
	 */
	getBalanceFail(payload: AppError): ActionWithPayload {
		return {
			type: LOYALTY_ACTION_TYPE.getBalanceFail,
			payload,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.LoyaltyMonthlyHistory)" instead
	 */
	getMonthlyHistory(): Action {
		return {
			type: LOYALTY_ACTION_TYPE.getMonthlyHistory,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.LoyaltyMonthlyHistory)" instead
	 */
	getMonthlyHistorySuccess(payload: LoyaltyMonthlyHistoryResponse): ActionWithPayload {
		return {
			type: LOYALTY_ACTION_TYPE.getMonthlyHistorySuccess,
			payload,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.LoyaltyMonthlyHistory)" instead
	 */
	getMonthlyHistoryFail(payload: AppError): ActionWithPayload {
		return {
			type: LOYALTY_ACTION_TYPE.getMonthlyHistoryFail,
			payload,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.LoyaltyHistory)" instead
	 */
	getHistory(payload: LoyaltyHistoryFilter = {}): ActionWithPayload {
		return {
			type: LOYALTY_ACTION_TYPE.getHistory,
			payload,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.LoyaltyHistory)" instead
	 */
	getHistorySuccess(payload: LoyaltyHistoryResponse): ActionWithPayload {
		return {
			type: LOYALTY_ACTION_TYPE.getHistorySuccess,
			payload,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.LoyaltyHistory)" instead
	 */
	getHistoryFail(payload: AppError): ActionWithPayload {
		return {
			type: LOYALTY_ACTION_TYPE.getHistoryFail,
			payload,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.dispatch(AccountAppCommand.LoyaltyExchangePoints)" instead
	 */
	exchangePoints(payload: number): ActionWithPayload {
		return {
			type: LOYALTY_ACTION_TYPE.exchangePoints,
			payload,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.dispatch(AccountAppCommand.LoyaltyExchangePoints)" instead
	 */
	exchangePointsSuccess(payload: number): ActionWithPayload {
		return {
			type: LOYALTY_ACTION_TYPE.exchangePointsSuccess,
			payload,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.dispatch(AccountAppCommand.LoyaltyExchangePoints)" instead
	 */
	exchangePointsFail(payload: AppError): ActionWithPayload {
		return {
			type: LOYALTY_ACTION_TYPE.exchangePointsFail,
			payload,
		};
	}
}
